import { useState } from "react";
import Modal from "../../common/components/Modal";
import TextInput from "../../common/components/formInputs/TextInput";
import PrimaryButton from "../../common/components/PrimaryButton";
import { validateEmail } from "../../common/helpers/common";
import PagePermissionsForm from "./PagePermissionsForm";

function InvitationForm({ open, setOpen, sendInvitationProps }) {
  const [email, setEmail] = useState("");

  const [pagePermissions, setPagePermissions] = useState({});

  const [errors, setErrors] = useState({});

  const { sendInvitationMutate, isSendingInvitation } = sendInvitationProps;

  return (
    <Modal
      title={"Invite"}
      open={open}
      setOpen={setOpen}
      containerCls="md:min-w-[500px]"
    >
      <TextInput
        label="Email"
        inputProps={{
          onChange: (e) => setEmail(e.target.value),
        }}
        error={errors?.email}
      />

      <PagePermissionsForm
        pagePermissions={pagePermissions}
        setPagePermissions={setPagePermissions}
        error={errors?.page}
      />

      <div className="my-4 mt-12">
        <PrimaryButton
          buttonProps={{
            onClick: () => {
              let error = {};

              if (!email) {
                error.email = "Email is required";
              }

              if (email && !validateEmail(email)) {
                error.email = "Invalid Email";
              }

              if (!Object.keys(pagePermissions)?.length) {
                error.page = "Please select atleast on page";
              }

              setErrors(error);

              // if no errors,
              if (!Object.keys(error)?.length) {
                const permissions = [];

                Object.entries(pagePermissions).forEach(([key, value]) => {
                  permissions.push({
                    page: key,
                    permissions: value,
                  });
                });

                const payload = {
                  email,
                  permissions,
                };

                sendInvitationMutate(payload);
              }
            },
          }}
          isLoading={isSendingInvitation}
        >
          Invite
        </PrimaryButton>
      </div>
    </Modal>
  );
}

export default InvitationForm;

function PageForm({
  page = {},
  permissions = [],
  isPageSelected,
  onPageSelect,
  onPermSelect,
}) {
  const { name } = page;
  return (
    <div>
      <div className="">
        <Checkbox
          label={name}
          onChange={(e) => onPageSelect(e.target.checked)}
          isChecked={isPageSelected}
        />
      </div>

      {isPageSelected ? (
        <div className="ml-4">
          {permissions.map((perm, i) => {
            const { label } = perm;

            const isPermissionSelected =
              isPageSelected && isPageSelected.includes(perm?._id);

            return (
              <div key={i} className="my-2">
                <Checkbox
                  label={label}
                  onChange={(e) => {
                    const isChecked = e.target.checked;

                    onPermSelect(isChecked, perm?._id);
                  }}
                  isChecked={isPermissionSelected}
                />
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}

function Checkbox({ label, onChange, isChecked }) {
  return (
    <div>
      <label>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={onChange}
          className="mr-2"
        />
        {label}
      </label>
    </div>
  );
}
